<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon1 {
    font-size: 20px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
	.avatar1 {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
<template>
	<div>
    <div class="m_context plr">
		<el-row>
			<el-col :span="24">
			  <el-form ref="addForm" id="addForm" :model="form" label-width="16%">

                <el-form-item :label="$t('lin_global.name')">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lin_global.version')">
                  <el-input v-model="form.version"></el-input>
                </el-form-item>

                <el-form-item :label="$t('lin_global.label_areaid')">
                    <!--<el-select filterable clearable v-model="form.targetId" :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
                       <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
                       <!--</el-option>-->
                    <!--</el-select>-->

                    <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
                </el-form-item>
                <el-form-item :label="$t('lin_global.xzqddhwj')">
				    <el-upload
					  class="upload-demo"
					  name="fileUpload"
					  drag
					  :action="action"
					  :on-success="handleAvatarScucess1"
					  :before-upload="beforeAvatarUpload">
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">{{$t('lin_global.jwjtdcc')}}<em>{{$t('lin_global.djsc')}}</em></div>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.pleaseUpload')}}</div>
					</el-upload>
			    </el-form-item>

			    <el-form-item :label="$t('lin_global.qxzkjlogo')">
				  <el-upload
					  class="avatar-uploader"
					  name="fileUpload"
					  :action="action"
					  :show-file-list="false"
					  :on-success="handleAvatarScucess2"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="imageUrl" :src="imageUrl" class="avatar1">
					  <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.tpxzds')}}</div>
				  </el-upload>
			  </el-form-item>
			    <el-form-item :label="$t('lin_global.zmlaun')">
				    <el-upload
					  class="upload-demo"
					  name="fileUpload"
					  drag
					  :action="action"
					  :on-success="handleAvatarScucess3"
					  :before-upload="beforeAvatarUpload">
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">{{$t('lin_global.jwjtdcc')}}<em>{{$t('lin_global.djsc')}}</em></div>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.pleaseUpload')}}</div>
					</el-upload>
			    </el-form-item>
			    <el-form-item :label="$t('lin_global.xtjcb')">
				    <el-upload
					  class="upload-demo"
					  name="fileUpload"
					  drag
					  :action="action"
					  :on-success="handleAvatarScucess4"
					  :before-upload="beforeAvatarUpload">
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">{{$t('lin_global.jwjtdcc')}}<em>{{$t('lin_global.djsc')}}</em></div>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.pleaseUpload')}}</div>
					</el-upload>
			    </el-form-item>
				<el-form-item>
                  <el-checkbox v-model="checked" @change="check">{{$t('lin_global.zdqmTips')}}</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
                  <el-button type="primary" :loading="isSubmit" @click="onSubmit">{{$t('lin_btn.add')}}</el-button>
                </el-form-item>

              </el-form>
			</el-col>
		</el-row>
    </div>
	</div>
</template>
<script>
	import axios from 'axios'
    import { baseurl,url,urlAssets } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
		data(){
      var that = this
			return{
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.targetId = value
//            that.cSelect(value)
          }
        },
				action:`${urlAssets.fileUrl}`,
        action1:`${urlAssets.picUrl}`,
        imgul:`${urlAssets.prefix}`,
				checked: false,
				imageUrl: '',
				form:{
					name:'',
					version:'',
					targetId:'',
					autoSign:'1',
					animatUrl:'',
					logoUrl:'',
					launcher:'',
					package_url:''
				},
				areaList:[]
			}
		},
		created(){
//			this.getAd();
		},
		methods:{
			onSubmit:function(){
				var params = this.form;
				//console.log("打印传入参数");
				//console.log(params)
        this.isSubmit = true;
				axios.post(`${baseurl}/ota_rom/makeRom.do`,params).then(res=>{
					//console.log("打印返回数据");
					//console.log(res.data)
		            if(res.data.status == 200){
		            	this.$message.success(res.data.message);
          this.isSubmit = false;
		            }else{
		            	this.$message.error(res.data.message)
          this.isSubmit = false;
		            }
		        })
			},
			check:function(){
				if(this.checked){
					this.form.autoSign = '0'
				}else{
					this.form.autoSign = '1'
				}
			},
			getAd:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		this.areaList = res.data.data;
		    	})
		    },
		    handleAvatarScucess1(res, file) {
		        //console.log("打印上传后返回");
		        //console.log(res);
		        this.form.animatUrl = res.fileUrl;
		    },
		    handleAvatarScucess2(res, file) {
		        //console.log("打印上传后返回");
		        //console.log(res);
		        this.form.logoUrl = res.fileUrl;
		        this.imageUrl = this.imgul+res.fileUrl
		    },
		    handleAvatarScucess3(res, file) {
		        //console.log("打印上传后返回");
		        //console.log(res);
		        this.form.launcher = res.fileUrl;
		    },
		    handleAvatarScucess4(res, file) {
		        //console.log("打印上传后返回");
		        //console.log(res);
		        this.form.package_url = res.fileUrl;
		    },
		    beforeAvatarUpload(file) {

		    },
			onCancel:function(){
				this.$router.go(-1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// romOrder.vue?6304b2ce